import React from "react";

import Alert from '@material-ui/lab/Alert'
import Snackbar from '@material-ui/core/Snackbar';
import { withStyles } from "@material-ui/core/styles";

/**
 * Snackbar customization to avoid overlapping the footer.
 */
const SnackbarStyled = withStyles({
  root: {
    bottom: "10%"
  }
})(Snackbar);

export class SnackbarCustom extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      message: null,
      severity: "info"
    }
  }

  /**
   * Receiving the information of component.
   */
  componentDidMount() {
    this.setState({ message: this.normalizeMessage(this.props.message), severity: this.props.severity })
  }
  
  componentDidUpdate(prevProps) {
    if (prevProps.message === this.props.message) return

    this.setState({ message: this.normalizeMessage(this.props.message), severity: this.props.severity })
  }
  
  normalizeMessage = (value) => {
    if (value === null || value === undefined) return null
    const message = String(value).trim()
    return message.length > 0 ? message : null
  }

  /**
   * To indicate that the draft has already been loaded
  */
  handleonClose = () => {
    this.setState({ message: null }, () => { this.props.handleonClose() })
  }

  render() {
    return (
      <React.Fragment>
        <SnackbarStyled open={Boolean(this.state.message)} autoHideDuration={20000} onClose={this.handleonClose} >
          <Alert className="typography-generic white-space-pre" severity={this.state.severity} variant="filled">
            {this.state.message}
          </Alert>
        </SnackbarStyled>
      </React.Fragment>
    )
  }
    
}


// WEBPACK FOOTER //
// ./src/components/Utilities/SnackbarCustom.js